export default __webpack_public_path__ + "static/media/ISCO CLASS-8 EXAM PATTERN 2025.cbe9dfb7.pdf";